function e(e){const n=document.createElement("a");document.body.appendChild(n),n.href=e,n.style.display="none",n.click(),document.body.removeChild(n)}export{e as downloadFile};
